const useHideOverlay = (asPath, isModalOpen) => {
	const pages = [
		"/the-farm/*",
		"/profiles/*",
		"/farmers",
		"/wheel-of-fortune/history",
	]

	if (asPath === "/" || isModalOpen) {
		return true
	} else {
		const pageFound = pages.find((page) => {
			if (page.includes("*")) {
				const pageSplit = page.split("/")
				pageSplit.pop()
				return asPath.includes(pageSplit.join("/"))
			}
			return asPath === page
		})
		return !!pageFound
	}
}

export default useHideOverlay
